// extracted by mini-css-extract-plugin
export default {"isContainer":"excerpt_isContainer__D1RkM","quote":"excerpt_quote__2L3LC","body":"excerpt_body__2c6fy","author":"excerpt_author__2RkLv"};